import { ContractorThemeKey } from "constants/ContractorThemes"
import { ApiTypes } from "types"
import { StorageKeys } from "types/enums/StorageKeys"

type StorageValue<T extends StorageKeys> =
  | (T extends StorageKeys.Token ? string : never)
  | (T extends StorageKeys.EnterpriseMasterAccountToken ? string : never)
  | (T extends StorageKeys.EnterpriseContractorsMenuDropdown ? Array<{ id: number; name: string }> : never)
  | (T extends StorageKeys.IsPrivacyChecked ? boolean : never)
  | (T extends StorageKeys.UserProfile ? ApiTypes.Model.UserProfile : never)
  | (T extends StorageKeys.TechnicianSN ? string : never)
  | (T extends StorageKeys.UserTemperatureScale ? "celsius" | "fahrenheit" : never)
  | (T extends StorageKeys.UserTheme ? ContractorThemeKey : never)
  | (T extends StorageKeys.UserLogo ? string : never)
  | (T extends StorageKeys.VerticalMenuOpen ? boolean : never)

export const setStorageItem = <T extends StorageKeys>(key: T, value: StorageValue<T>): void => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getStorageItem = <T extends StorageKeys>(key: T): StorageValue<T> | null => {
  const item = localStorage.getItem(key)

  if (!item) return null

  try {
    return JSON.parse(item) as StorageValue<T>
  } catch {
    return item as StorageValue<T>
  }
}

export const removeStorageItem = (key: StorageKeys): void => {
  localStorage.removeItem(key)
}

export const clearStorage = (): void => {
  localStorage.clear()
}
